import { useState } from "react";
import { t } from "@/i18n-js/instance";
import type { BaseFilter } from "@/react/components/shared/MemberFilters/types";
import { CommunityMembers } from "@/react/components/shared/MembersList/CommunityMembers/CommunityMembersV2";
import type { Views } from "@/react/components/shared/MembersList/constants";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { MemberFilterDesignProvider } from "../../shared/FilterV3/MemberFilterDesignContext";
import { Filters } from "../../shared/MembersList/Filters";
import { MembersFilters } from "../Header/MembersFilters";
import type { MemberDirectorySettings } from "../constants";

interface MemberListWithFiltersProps {
  activeView?: Views;
  baseFilters?: BaseFilter[];
  memberDirectorySettings?: MemberDirectorySettings;
  rightHeaderContent?: React.ReactNode;
  shouldShowHiddenMemberTooltip?: boolean;
  titleI18nKey: string;
}

export const MemberListWithFilters = ({
  activeView,
  baseFilters,
  memberDirectorySettings,
  shouldShowHiddenMemberTooltip = true,
  titleI18nKey,
  rightHeaderContent,
}: MemberListWithFiltersProps) => {
  const [memberCount, setMemberCount] = useState(0);

  return (
    <div className="flex flex-col gap-6">
      <div className="border-primary flex items-center justify-between">
        <div className="flex items-center gap-x-2 pl-2 md:pl-0">
          <Typography.LabelLg weight="semibold">
            {t(titleI18nKey)}
          </Typography.LabelLg>
          {memberCount > 0 && (
            <span className="bg-secondary text-dark flex h-[22px] items-center justify-center rounded-3xl px-1.5 py-0.5 text-center text-xs font-medium">
              {memberCount}
            </span>
          )}
        </div>
        {rightHeaderContent}
      </div>
      <MemberFilterDesignProvider enabled>
        <MembersFilters
          className="shadow-none"
          filterRowClassName="!p-0 !border-none "
        />
      </MemberFilterDesignProvider>

      <Filters />

      <CommunityMembers
        setMemberCount={setMemberCount}
        defaultSort={memberDirectorySettings?.defaultSort}
        shouldShowHiddenMemberTooltip={shouldShowHiddenMemberTooltip}
        activeView={activeView}
        baseFilters={baseFilters}
      />
    </div>
  );
};
